export default "__VITE_ASSET__BETZDiW3__"